import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { SimpleInputDialogData, SimpleInputDialogType } from '@app/shared/models/dialog-data';
import { ConfirmModalComponent } from '@app/shared/dialogs/confirm-dialog/confirm-modal.component';

@Component({
    selector: 'simple-input-dialog',
    templateUrl: './simple-input-dialog.component.html'
})
export class SimpleInputDialogComponent extends ConfirmModalComponent implements OnInit {

    public inputValue: any;

    constructor(public dialogRef: MatDialogRef<SimpleInputDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: SimpleInputDialogData) {
        super(dialogRef, data);
        this._idPrefix = 'simple_input_dialog.';
    }

    public ngOnInit() {
        this.data.inputType = this.data.inputType || SimpleInputDialogType.TEXT;
    }

    public accept(): void {
        this.dialogRef.close({ input: this.inputValue });
    }
}
